export default __webpack_public_path__ + "locales/es/Translations.json?hash=37eafa18ee4b951f84989ea4868a7351";